import { render } from "./ForgotPasswordVerifyView.vue?vue&type=template&id=da07e1ba&scoped=true"
import script from "./ForgotPasswordVerifyView.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordVerifyView.vue?vue&type=script&lang=js"

import "./ForgotPasswordVerifyView.vue?vue&type=style&index=0&id=da07e1ba&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da07e1ba"]])

export default __exports__